(function() {
  'use strict';

  const TTS_ENDPOINT = window.KA_TTS_ENDPOINT || 'https://tts-serverless-service-lac.vercel.app/api/tts';

  var articleWrapper = document.querySelector('.ka-read-aloud-component');
  var ARTICLE_ID = (articleWrapper && articleWrapper.getAttribute('data-article-id')) || window.location.pathname.replace(/\W+/g, '_');
  var ARTICLE_TITLE = (articleWrapper && articleWrapper.getAttribute('data-article-title')) || document.title;
  var ARTICLE_UPDATED_AT = (articleWrapper && articleWrapper.getAttribute('data-updated-at')) || '0';

  var currentVoice = 'en-IN-NeerjaNeural';
  var currentSpeed = 1.0;
  var isPlaying = false;
  var currentAudio = null;
  var boundaries = [];
  var domSpans = [];
  var rafId = null;
  var lastIdx = -1;
  var isScrubbing = false;
  var isShowingRemaining = true;
  var userScrollTime = 0;
  var activeParent = null;
  var isPreparingAudio = false;
  var currentTotalDuration = 0;

  function dataUriToBlobUrl(dataUri) {
    if (!dataUri || typeof dataUri !== 'string' || !dataUri.startsWith('data:audio/')) return dataUri;
    try {
      var commaIdx = dataUri.indexOf(',');
      if (commaIdx === -1) return dataUri;
      var mime = dataUri.substring(5, dataUri.indexOf(';')) || 'audio/mp3';
      var b64 = dataUri.substring(commaIdx + 1);
      var binary = atob(b64);
      var len = binary.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      var blob = new Blob([bytes], { type: mime });
      return URL.createObjectURL(blob);
    } catch (e) {
      return dataUri;
    }
  }

  var trigger = document.getElementById('ka-read-aloud-trigger');

  var player = document.getElementById('ka-read-aloud-player');
  var playBtn = player && player.querySelector('.ka-read-aloud-play-btn');
  var stopBtn = player && player.querySelector('.ka-read-aloud-stop-btn');
  var speedBtn = player && player.querySelector('.ka-read-aloud-speed-btn');
  var speedDropdown = player && player.querySelector('.ka-read-aloud-speed-dropdown');
  var rewindBtn = player && player.querySelector('.ka-read-aloud-rewind-btn');
  var forwardBtn = player && player.querySelector('.ka-read-aloud-forward-btn');
  var deskTimeDisplay = document.getElementById('ka-desk-time');
  var deskVolToggle = document.getElementById('ka-desk-vol-toggle');

  var mobileCard = document.getElementById('ka-mobile-player-card');
  var mpPlayBtn = document.getElementById('ka-mp-play');
  var mpRewindBtn = document.getElementById('ka-mp-rewind');
  var mpForwardBtn = document.getElementById('ka-mp-forward');
  var mpRange = document.getElementById('ka-mp-range');
  var mpTimeCurrent = document.getElementById('ka-mp-time-current');
  var mpTimeTotal = document.getElementById('ka-mp-time-total');
  var mpSpeedBtn = document.getElementById('ka-mp-speed-btn');
  var mpStopBtn = document.getElementById('ka-mp-stop');
  var mpMuteBtn = document.getElementById('ka-mp-mute');

  if (trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      startReader('entire');
    });
  }

  function syncDesktopTriggerPosition() {
    var t = trigger || document.getElementById('ka-read-aloud-trigger');
    if (!t) return;
    var sidebar = document.querySelector('.ka-article-sidebar');
    if (window.innerWidth >= 990 && sidebar && sidebar.offsetParent !== null) {
      var rect = sidebar.getBoundingClientRect();
      var rightOffset = window.innerWidth - rect.right;
      if (rightOffset > 0) {
        t.style.right = Math.max(16, rightOffset) + 'px';
      }
    } else {
      t.style.right = '';
    }
  }

  function checkTriggerVisibility() {
    var t = trigger || document.getElementById('ka-read-aloud-trigger');
    var p = player || document.getElementById('ka-read-aloud-player');
    var mc = mobileCard || document.getElementById('ka-mobile-player-card');

    syncDesktopTriggerPosition();

    if (!t) return;
    if (isPlaying || (p && p.classList.contains('is-active')) || (mc && mc.classList.contains('is-active'))) {
      t.classList.add('ka-hidden');
      t.classList.remove('is-active-sticky');
      return;
    }

    var reached = false;
    var sidebar = document.querySelector('.ka-article-sidebar');
    if (window.innerWidth >= 990 && sidebar && sidebar.offsetParent !== null) {
      var sidebarTop = sidebar.getBoundingClientRect().top;
      reached = sidebarTop <= 156;
    } else {
      var mobileToc = document.querySelector('.ka-article-toc-mobile');
      if (mobileToc && mobileToc.offsetParent !== null) {
        reached = mobileToc.getBoundingClientRect().bottom <= 80;
      } else {
        reached = window.pageYOffset >= 350;
      }
    }

    var articleLayout = document.querySelector('.ka-article-layout');
    var recProducts = document.querySelector('.ka-article-products, #products, .ka-product-recommendations, .ka-article-post-body');
    var pastEnd = false;

    if (recProducts) {
      pastEnd = recProducts.getBoundingClientRect().top <= (window.innerHeight * 0.5);
    } else if (articleLayout) {
      pastEnd = articleLayout.getBoundingClientRect().bottom <= (window.innerHeight * 0.5);
    } else {
      var footer = document.querySelector('footer, .theme-footer');
      if (footer) {
        pastEnd = footer.getBoundingClientRect().top <= (window.innerHeight * 0.85);
      }
    }

    var isVisible = reached && !pastEnd;
    t.classList.toggle('ka-hidden', !isVisible);
    t.classList.toggle('is-active-sticky', isVisible);
  }
  function handleViewportResize() {
    syncDesktopTriggerPosition();
    checkTriggerVisibility();
    if (isPlaying && currentAudio) {
      updateProgress(currentAudio.currentTime, getEffectiveDuration());
    }
  }
  window.addEventListener('scroll', checkTriggerVisibility, { passive: true });
  window.addEventListener('resize', handleViewportResize, { passive: true });
  window.addEventListener('orientationchange', handleViewportResize, { passive: true });
  setTimeout(checkTriggerVisibility, 500);

  function extractTargetElements() {
    var container = document.querySelector('.ka-article-body') || document.querySelector('.ka-article-content') || document.body;
    if (!container) return [];
    var rawEls = Array.from(container.querySelectorAll('h1, h2, h3, h4, p, li, blockquote, .ka-key-takeaways-item, .ka-article-did-you-know-text'));
    var excluded = 'script, style, noscript, svg, template, code, pre, [data-read-aloud="false"], [data-read-aloud="false"] *, .ka-author-reviewer-component, .ka-expert-card, .ka-article-toc-card, .ka-article-sidebar, footer, .theme-footer, .ka-article-post-body, .ka-comments-section, .ka-product-recommendations, .ka-product-breaker, .ka-quiz-breaker, .ka-doctor-consult-banner';
    return rawEls.filter(function(el) {
      if (el.matches(excluded) || el.closest(excluded)) return false;
      var clean = el.cloneNode(true);
      clean.querySelectorAll('script, style, noscript, svg, template, code, pre, [data-read-aloud="false"]').forEach(function(s) { s.remove(); });
      var t = clean.textContent.trim();
      if (t.length < 2) return false;
      if (/^(function\s*\(|\(function|\.[\w-]+\s*\{|\{[\s\S]*\}$)/.test(t)) return false;
      return !rawEls.some(function(p) { return p !== el && p.contains(el) && !p.closest(excluded); });
    });
  }

  function tokenizeElements(elements) {
    domSpans = [];
    var globalIdx = 0;
    elements.forEach(function(el) {
      if (!el.hasAttribute('data-original-html')) el.setAttribute('data-original-html', el.innerHTML);
      el.classList.add('ka-reading-unread');
      function walk(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          var tag = (node.tagName || '').toLowerCase();
          if (tag === 'script' || tag === 'style' || tag === 'svg' || tag === 'noscript' || tag === 'template' || tag === 'code' || tag === 'pre') {
            return;
          }
        }
        if (node.nodeType === Node.TEXT_NODE) {
          var raw = node.nodeValue;
          if (!raw || !raw.trim()) return;
          var frag = document.createDocumentFragment();
          var regex = /\S+/g, match, last = 0;
          while ((match = regex.exec(raw)) !== null) {
            if (match.index > last) frag.appendChild(document.createTextNode(raw.substring(last, match.index)));
            var idx = globalIdx;
            var span = document.createElement('span');
            span.className = 'ka-read-word ka-word-unread';
            span.setAttribute('data-idx', idx);
            span.textContent = match[0];
            span.addEventListener('click', (function(i) { return function(e) { e.stopPropagation(); seekToWord(i); }; })(idx));
            frag.appendChild(span);
            domSpans.push({ span: span, parentEl: el });
            globalIdx++;
            last = regex.lastIndex;
          }
          if (last < raw.length) frag.appendChild(document.createTextNode(raw.substring(last)));
          if (node.parentNode) node.parentNode.replaceChild(frag, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          Array.from(node.childNodes).forEach(walk);
        }
      }
      walk(el);
    });
  }

  function restoreDOM() {
    document.body.classList.remove('ka-read-aloud-active');
    document.querySelectorAll('.ka-reading-active, .ka-reading-unread, .ka-reading-read').forEach(function(el) {
      el.classList.remove('ka-reading-active', 'ka-reading-unread', 'ka-reading-read');
    });
    document.querySelectorAll('[data-original-html]').forEach(function(el) {
      el.innerHTML = el.getAttribute('data-original-html');
      el.removeAttribute('data-original-html');
    });
    domSpans = [];
    boundaries = [];
    lastIdx = -1;
    activeParent = null;
  }

  function fallbackHash(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) { h = ((h << 5) - h) + str.charCodeAt(i); h |= 0; }
    return Math.abs(h).toString(36);
  }

  function computeHash(voice, str, updatedAt) {
    var v = updatedAt ? String(updatedAt).trim() : '0';
    var combined = voice + ':' + v + ':' + str;
    if (window.crypto && window.crypto.subtle) {
      try {
        var buf = new TextEncoder().encode(combined);
        return window.crypto.subtle.digest('SHA-256', buf).then(function(hashBuf) {
          var hashArray = Array.from(new Uint8Array(hashBuf));
          return hashArray.map(function(b) { return b.toString(16).padStart(2, '0'); }).join('');
        }).catch(function() {
          return fallbackHash(combined);
        });
      } catch(e) {}
    }
    return Promise.resolve(fallbackHash(combined));
  }

  function storeInClientCache(key, data) {
    try { localStorage.setItem(key, JSON.stringify(data)); return; } catch(e) {}
    try { sessionStorage.setItem(key, JSON.stringify(data)); return; } catch(e) {}
  }

  function getFromClientCache(key) {
    try {
      var item = localStorage.getItem(key) || sessionStorage.getItem(key);
      if (item) return JSON.parse(item);
    } catch(e) {}
    return null;
  }

  function splitIntoSafeSegments(text, maxChars) {
    var limit = maxChars || 2400;
    if (text.length <= limit) return [text];
    var paragraphs = text.split(/\n\n+/);
    var segments = [];
    var current = "";

    for (var i = 0; i < paragraphs.length; i++) {
      var para = paragraphs[i].trim();
      if (!para) continue;
      var candidate = current ? current + "\n\n" + para : para;
      if (candidate.length <= limit) {
        current = candidate;
      } else {
        if (current) segments.push(current);
        if (para.length > limit) {
          var sentences = para.split(/(?<=[.!?])\s+/);
          var sCur = "";
          for (var s = 0; s < sentences.length; s++) {
            var sent = sentences[s].trim();
            if (!sent) continue;
            var sCand = sCur ? sCur + " " + sent : sent;
            if (sCand.length <= limit) {
              sCur = sCand;
            } else {
              if (sCur) segments.push(sCur);
              sCur = sent;
            }
          }
          current = sCur;
        } else {
          current = para;
        }
      }
    }
    if (current) segments.push(current);
    return segments.length ? segments : [text];
  }

  function fetchSingleSegment(plainText, voice) {
    return computeHash(voice, plainText, ARTICLE_UPDATED_AT).then(function(textHash) {
      var cacheKey = 'ka_tts_v13_' + ARTICLE_ID + '_' + (ARTICLE_UPDATED_AT || '0') + '_' + textHash;
      
      var localCached = getFromClientCache(cacheKey);
      if (localCached && localCached.audioUrl) {
        return localCached;
      }

      var getUrl = TTS_ENDPOINT + '?id=' + encodeURIComponent(ARTICLE_ID) +
                   '&hash=' + encodeURIComponent(textHash) +
                   '&voice=' + encodeURIComponent(voice) +
                   '&v=' + encodeURIComponent(ARTICLE_UPDATED_AT);

      return fetch(getUrl, { method: 'GET' }).then(function(r) {
        if (r.ok) {
          return r.json().then(function(data) {
            if (data && data.audioUrl) {
              storeInClientCache(cacheKey, data);
              return data;
            }
            throw new Error('Invalid edge cache payload');
          });
        }
        throw new Error('Cache miss');
      }).catch(function() {
        return fetch(TTS_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            text: plainText,
            voice: voice,
            hash: textHash,
            articleId: ARTICLE_ID,
            v: ARTICLE_UPDATED_AT
          })
        }).then(function(r) {
          if (!r.ok) {
            return r.json().catch(function() { return {}; }).then(function(errData) {
              var msg = (errData && (errData.message || errData.error)) || ('HTTP ' + r.status);
              throw new Error('TTS request failed: ' + msg);
            });
          }
          return r.json();
        }).then(function(data) {
          if (data && data.audioUrl) {
            storeInClientCache(cacheKey, data);
          }
          return data;
        });
      });
    });
  }

  function mergePayloads(payloadList) {
    if (!payloadList || !payloadList.length) throw new Error('No audio payloads to merge');
    if (payloadList.length === 1) return payloadList[0];

    var combinedBuffers = [];
    var allBoundaries = [];
    var runningOffsetMs = 0;
    var globalWordIdx = 0;
    var totalDuration = 0;

    payloadList.forEach(function(payload) {
      if (payload.audioUrl) {
        var commaIdx = payload.audioUrl.indexOf(',');
        var b64 = commaIdx !== -1 ? payload.audioUrl.substring(commaIdx + 1) : payload.audioUrl;
        var binary = atob(b64);
        var len = binary.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        combinedBuffers.push(bytes);
      }

      (payload.boundaries || []).forEach(function(b) {
        allBoundaries.push({
          wordIndex: globalWordIdx + (b.wordIndex || 0),
          text: b.text,
          startMs: (b.startMs || 0) + runningOffsetMs,
          endMs: (b.endMs || 0) + runningOffsetMs
        });
      });

      var segDur = (payload.durationSec && isFinite(payload.durationSec) && payload.durationSec > 0)
        ? payload.durationSec
        : (payload.boundaries && payload.boundaries.length ? payload.boundaries[payload.boundaries.length - 1].endMs / 1000 : 0);
      
      runningOffsetMs += Math.round(segDur * 1000);
      totalDuration += segDur;
      globalWordIdx += (payload.wordCount || (payload.boundaries ? payload.boundaries.length : 0));
    });

    var blob = new Blob(combinedBuffers, { type: 'audio/mp3' });
    var audioUrl = URL.createObjectURL(blob);

    return {
      success: true,
      audioUrl: audioUrl,
      durationSec: parseFloat(totalDuration.toFixed(2)),
      wordCount: globalWordIdx,
      boundaries: allBoundaries
    };
  }

  function fetchTTS(plainText, voice) {
    var segments = splitIntoSafeSegments(plainText, 2400);
    if (segments.length <= 1) {
      return fetchSingleSegment(plainText, voice);
    }

    var results = new Array(segments.length);
    var nextIdx = 0;

    function worker() {
      if (nextIdx >= segments.length) return Promise.resolve();
      var idx = nextIdx++;
      return fetchSingleSegment(segments[idx], voice).then(function(res) {
        results[idx] = res;
        return worker();
      });
    }

    var workers = [worker(), worker()];
    return Promise.all(workers).then(function() {
      return mergePayloads(results);
    });
  }

  var LOOK_AHEAD_MS = 75;
  var isSeeking = false;
  var seekLockTimeout = null;

  function startSyncLoop() {
    cancelAnimationFrame(rafId);
    function tick() {
      if (!currentAudio || currentAudio.paused || !isPlaying) return;
      if (!isSeeking) {
        var rawMs = currentAudio.currentTime * 1000;
        var dur = getEffectiveDuration();
        updateProgress(currentAudio.currentTime, dur);
        var idx = findWordAt(rawMs + LOOK_AHEAD_MS);
        if (idx !== -1 && idx !== lastIdx) {
          highlightWord(idx);
        }
      }
      rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);
  }

  function findWordAt(ms) {
    if (!boundaries.length) return -1;
    var lo = 0, hi = boundaries.length - 1, best = 0;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (boundaries[mid].startMs <= ms) { best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    return best;
  }

  function highlightWord(idx, forceScroll) {
    if (idx < 0 || idx >= domSpans.length) return;

    if (!forceScroll && lastIdx >= 0 && Math.abs(idx - lastIdx) <= 3) {
      if (lastIdx < idx) {
        for (var k = lastIdx; k < idx; k++) if (domSpans[k]) domSpans[k].span.className = 'ka-read-word ka-word-read';
      } else {
        for (var k = lastIdx; k > idx; k--) if (domSpans[k]) domSpans[k].span.className = 'ka-read-word ka-word-unread';
      }
      if (domSpans[idx]) domSpans[idx].span.className = 'ka-read-word ka-word-active';
    } else {
      for (var i = 0; i < domSpans.length; i++) {
        if (i < idx) domSpans[i].span.className = 'ka-read-word ka-word-read';
        else if (i === idx) domSpans[i].span.className = 'ka-read-word ka-word-active';
        else domSpans[i].span.className = 'ka-read-word ka-word-unread';
      }
    }
    lastIdx = idx;

    var obj = domSpans[idx];
    var currentParent = obj ? obj.parentEl : null;
    if (currentParent !== activeParent || forceScroll) {
      activeParent = currentParent;
      var seenCurrent = false;
      var allParents = [];
      for (var p = 0; p < domSpans.length; p++) {
        var pel = domSpans[p].parentEl;
        if (pel && allParents.indexOf(pel) === -1) {
          allParents.push(pel);
        }
      }
      allParents.forEach(function(pel) {
        if (pel === activeParent) {
          seenCurrent = true;
          pel.classList.remove('ka-reading-unread', 'ka-reading-read');
          pel.classList.add('ka-reading-active');
        } else if (!seenCurrent) {
          pel.classList.remove('ka-reading-unread', 'ka-reading-active');
          pel.classList.add('ka-reading-read');
        } else {
          pel.classList.remove('ka-reading-read', 'ka-reading-active');
          pel.classList.add('ka-reading-unread');
        }
      });
    }

    if (obj && (forceScroll || Date.now() - userScrollTime > 4000)) {
      var rect = obj.span.getBoundingClientRect();
      if (forceScroll || rect.top < 140 || rect.bottom > window.innerHeight - 160) {
        obj.span.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  window.addEventListener('wheel', function() { userScrollTime = Date.now(); }, { passive: true });
  window.addEventListener('touchmove', function() { userScrollTime = Date.now(); }, { passive: true });

  function seekToWord(idx) {
    if (!currentAudio || !boundaries[idx]) return;
    isSeeking = true;
    clearTimeout(seekLockTimeout);

    var targetSec = Math.max(0, boundaries[idx].startMs / 1000);
    currentAudio.currentTime = targetSec;
    highlightWord(idx, true);

    if (currentAudio.paused) {
      currentAudio.play().catch(function() {});
      togglePlayPauseUI(true);
    }

    seekLockTimeout = setTimeout(function() {
      isSeeking = false;
    }, 180);
  }

  function renderScrubber(pct, isDragging) {
    var container = document.getElementById('ka-mp-bar-container');
    var svg = document.getElementById('ka-mp-bar-svg');
    var svgTrack = document.getElementById('ka-mp-svg-track');
    var svgFill = document.getElementById('ka-mp-svg-fill');
    var thumbDot = document.getElementById('ka-mp-thumb-dot');
    if (!container || !svg || !svgTrack || !svgFill || !thumbDot) return;

    var W = container.clientWidth || container.offsetWidth || 200;
    svg.setAttribute('viewBox', '0 0 ' + W.toFixed(1) + ' 24');

    var Y_base = 12;
    var clampPct = Math.min(100, Math.max(0, pct));
    var X = (clampPct / 100) * W;

    if (isDragging) {
      container.classList.add('is-dragging');
      var Y_knob = 4;
      var R = Math.min(55, Math.max(25, W * 0.28));

      var leftFactor = Math.min(1, Math.max(0, X / R));
      var rightFactor = Math.min(1, Math.max(0, (W - X) / R));

      var startY = Y_knob + (Y_base - Y_knob) * leftFactor;
      var endY = Y_knob + (Y_base - Y_knob) * rightFactor;

      var X_start = Math.max(0, X - R);
      var X_end = Math.min(W, X + R);

      var fillD = "M 0," + startY.toFixed(1);
      if (X > 0) {
        if (X_start > 0) {
          fillD += " L " + X_start.toFixed(1) + "," + Y_base;
          fillD += " C " + (X_start + (X - X_start) * 0.5).toFixed(1) + "," + Y_base + " " +
                          (X_start + (X - X_start) * 0.65).toFixed(1) + "," + Y_knob + " " +
                          X.toFixed(1) + "," + Y_knob;
        } else {
          fillD += " C " + (X * 0.5).toFixed(1) + "," + startY.toFixed(1) + " " +
                          (X * 0.75).toFixed(1) + "," + Y_knob + " " +
                          X.toFixed(1) + "," + Y_knob;
        }
      }

      var trackD = "M 0," + startY.toFixed(1);
      if (X_start > 0) {
        trackD += " L " + X_start.toFixed(1) + "," + Y_base;
        trackD += " C " + (X_start + (X - X_start) * 0.5).toFixed(1) + "," + Y_base + " " +
                          (X_start + (X - X_start) * 0.65).toFixed(1) + "," + Y_knob + " " +
                          X.toFixed(1) + "," + Y_knob;
      } else if (X > 0) {
        trackD += " C " + (X * 0.5).toFixed(1) + "," + startY.toFixed(1) + " " +
                          (X * 0.75).toFixed(1) + "," + Y_knob + " " +
                          X.toFixed(1) + "," + Y_knob;
      }

      if (X_end < W) {
        trackD += " C " + (X + (X_end - X) * 0.35).toFixed(1) + "," + Y_knob + " " +
                          (X + (X_end - X) * 0.5).toFixed(1) + "," + Y_base + " " +
                          X_end.toFixed(1) + "," + Y_base;
        trackD += " L " + W.toFixed(1) + "," + Y_base;
      } else {
        var distRight = W - X;
        if (distRight > 0) {
          trackD += " C " + (X + distRight * 0.35).toFixed(1) + "," + Y_knob + " " +
                            (X + distRight * 0.5).toFixed(1) + "," + endY.toFixed(1) + " " +
                            W.toFixed(1) + "," + endY.toFixed(1);
        }
      }

      svgTrack.setAttribute('d', trackD);
      svgFill.setAttribute('d', fillD);
      thumbDot.style.left = X.toFixed(1) + 'px';
      thumbDot.style.top = Y_knob + 'px';
    } else {
      container.classList.remove('is-dragging');
      var straightTrack = "M 0," + Y_base + " L " + W.toFixed(1) + "," + Y_base;
      var straightFill = "M 0," + Y_base + " L " + X.toFixed(1) + "," + Y_base;

      svgTrack.setAttribute('d', straightTrack);
      svgFill.setAttribute('d', straightFill);
      thumbDot.style.left = X.toFixed(1) + 'px';
      thumbDot.style.top = Y_base + 'px';
    }
  }

  function formatTime(s) {
    if (!s || isNaN(s) || !isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function getEffectiveDuration(total) {
    if (total && isFinite(total) && total > 0 && total !== Infinity) return total;
    if (currentAudio && currentAudio.duration && isFinite(currentAudio.duration) && currentAudio.duration > 0 && currentAudio.duration !== Infinity) {
      return currentAudio.duration;
    }
    if (boundaries && boundaries.length > 0 && boundaries[boundaries.length - 1].endMs) {
      return boundaries[boundaries.length - 1].endMs / 1000;
    }
    if (currentTotalDuration && isFinite(currentTotalDuration) && currentTotalDuration > 0) {
      return currentTotalDuration;
    }
    return 0;
  }

  function updateProgress(cur, total) {
    var dur = getEffectiveDuration(total);
    var safeCur = (cur && isFinite(cur) && cur >= 0) ? cur : 0;
    if (dur > 0 && safeCur > dur) safeCur = dur;

    var curFormatted = formatTime(safeCur);
    var totalFormatted = dur > 0 ? formatTime(dur) : (isPreparingAudio ? '--:--' : '0:00');
    var pct = dur > 0 ? Math.min(100, Math.max(0, (safeCur / dur) * 100)) : 0;

    if (!isScrubbing) {
      var rangeEl = mpRange || document.getElementById('ka-mp-range');
      if (rangeEl) {
        rangeEl.value = pct;
        renderScrubber(pct, false);
      }
    }

    var curEl = mpTimeCurrent || document.getElementById('ka-mp-time-current');
    if (curEl) curEl.textContent = curFormatted;

    var totalEl = mpTimeTotal || document.getElementById('ka-mp-time-total');
    if (totalEl) {
      var rem = Math.max(0, dur - safeCur);
      totalEl.textContent = isShowingRemaining ? ('-' + (dur > 0 ? formatTime(rem) : (isPreparingAudio ? '--:--' : '0:00'))) : totalFormatted;
    }

    var deskTime = deskTimeDisplay || document.getElementById('ka-desk-time');
    if (deskTime) deskTime.textContent = curFormatted + ' / ' + totalFormatted;
  }

  function startReader(mode, startHeading) {
    if (isPreparingAudio) return;
    stopReader();
    isPreparingAudio = true;
    var allElements = extractTargetElements();
    if (!allElements.length) {
      isPreparingAudio = false;
      return;
    }

    var masterText = allElements.map(function(el) {
      var clone = el.cloneNode(true);
      clone.querySelectorAll('script, style, noscript, svg, template, code, pre, [data-read-aloud="false"]').forEach(function(s) {
        s.remove();
      });
      var t = clone.textContent
        .replace(/&nbsp;|\u00A0/g, ' ')
        .replace(/&amp;/g, ' and ')
        .replace(/&/g, ' and ')
        .replace(/[ \t]+/g, ' ')
        .trim();
      return /[.!?]$/.test(t) ? t : t + '.';
    }).filter(function(t) {
      return t.length > 2 && !/^(function\s*\(|\(function|\.[\w-]+\s*\{|\{[\s\S]*\}$)/.test(t);
    }).join('\n\n');

    tokenizeElements(allElements);

    var targetStartIndex = 0;
    if (mode === 'section' && startHeading) {
      for (var si = 0; si < domSpans.length; si++) {
        if (domSpans[si].parentEl === startHeading || startHeading.contains(domSpans[si].span)) {
          targetStartIndex = si;
          break;
        }
      }
      startHeading.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (mode === 'takeaways') {
      var box = document.querySelector('.ka-key-takeaways-wrapper, #at-a-glance, .ka-key-takeaways-box, .ka-article-at-a-glance');
      if (box) {
        for (var ti = 0; ti < domSpans.length; ti++) {
          if (box.contains(domSpans[ti].span)) {
            targetStartIndex = ti;
            break;
          }
        }
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    document.body.classList.add('ka-read-aloud-active');

    // Instantly calculate estimated duration so the player displays realistic timing while preparing
    var rawWordCount = domSpans.length || masterText.split(/\s+/).filter(Boolean).length;
    var estDuration = Math.max(5, Math.round((rawWordCount / 145) * 60));
    currentTotalDuration = estDuration;

    showPlayer();
    setLoading(true);
    updateProgress(0, estDuration);

    fetchTTS(masterText, currentVoice).then(function(payload) {
      isPreparingAudio = false;
      setLoading(false);
      if (!payload || !payload.audioUrl) throw new Error('Invalid audio data');

      boundaries = payload.boundaries || [];
      var bDur = (boundaries.length > 0 && boundaries[boundaries.length - 1].endMs)
        ? (boundaries[boundaries.length - 1].endMs / 1000)
        : 0;
      currentTotalDuration = (payload.durationSec && isFinite(payload.durationSec) && payload.durationSec > 0)
        ? payload.durationSec
        : (bDur || estDuration);

      var audioSrc = dataUriToBlobUrl(payload.audioUrl);
      currentAudio = new Audio();
      currentAudio.preload = 'auto';
      currentAudio.playbackRate = currentSpeed;
      currentAudio.src = audioSrc;

      updateProgress(0, currentTotalDuration);

      var playbackStarted = false;
      function startPlaybackAtTarget() {
        if (playbackStarted) return;
        playbackStarted = true;
        if (currentAudio.duration && isFinite(currentAudio.duration) && currentAudio.duration > 0 && currentAudio.duration !== Infinity) {
          currentTotalDuration = currentAudio.duration;
        }
        var startMs = (boundaries[targetStartIndex] && boundaries[targetStartIndex].startMs) ? boundaries[targetStartIndex].startMs : 0;
        currentAudio.currentTime = Math.max(0, startMs / 1000);
        highlightWord(targetStartIndex, true);
        updateProgress(currentAudio.currentTime, currentTotalDuration);
        currentAudio.play().catch(function() { togglePlayPauseUI(false); });
      }

      currentAudio.addEventListener('loadedmetadata', function() {
        if (currentAudio.duration && isFinite(currentAudio.duration) && currentAudio.duration > 0 && currentAudio.duration !== Infinity) {
          currentTotalDuration = currentAudio.duration;
        }
        updateProgress(currentAudio.currentTime, currentTotalDuration);
        startPlaybackAtTarget();
      });
      currentAudio.addEventListener('canplay', function() {
        startPlaybackAtTarget();
      });
      if (currentAudio.readyState >= 1) {
        startPlaybackAtTarget();
      }

      currentAudio.addEventListener('timeupdate', function() {
        if (!isSeeking && !isScrubbing && currentAudio) {
          updateProgress(currentAudio.currentTime, getEffectiveDuration());
        }
      });
      currentAudio.addEventListener('play', function() {
        isPlaying = true; togglePlayPauseUI(true); startSyncLoop(); updateMediaSession();
      });
      currentAudio.addEventListener('pause', function() {
        isPlaying = false; togglePlayPauseUI(false); cancelAnimationFrame(rafId);
      });
      currentAudio.addEventListener('ended', function() { stopReader(); });
    }).catch(function(err) {
      isPreparingAudio = false;
      console.error('TTS Error:', err);
      setLoading(false);
      var titleEl = player ? player.querySelector('.ka-desk-player-title') : document.querySelector('.ka-desk-player-title');
      if (titleEl) {
        titleEl.textContent = 'Speech unavailable. Please retry.';
      }
      setTimeout(stopReader, 2500);
    });
  }

  function togglePlayPause() {
    if (!currentAudio) return;
    if (currentAudio.paused) {
      currentAudio.play().then(function() {
        isPlaying = true;
        togglePlayPauseUI(true);
        startSyncLoop();
      }).catch(function() {
        togglePlayPauseUI(false);
      });
    } else {
      currentAudio.pause();
      isPlaying = false;
      togglePlayPauseUI(false);
      cancelAnimationFrame(rafId);
    }
  }

  function togglePlayPauseUI(playing) {
    [playBtn, mpPlayBtn].forEach(function(b) { if (b) b.classList.toggle('is-paused', !playing); });
  }

  function showPlayer() {
    isPlaying = true;
    checkTriggerVisibility();
    if (player) player.classList.add('is-active');
    if (mobileCard) mobileCard.classList.add('is-active');
  }

  function setLoading(loading) {
    [player, mobileCard].forEach(function(el) { if (el) el.classList.toggle('is-loading', loading); });
    var titleEl = player ? player.querySelector('.ka-desk-player-title') : document.querySelector('.ka-desk-player-title');
    if (titleEl) {
      if (loading) {
        if (!titleEl.hasAttribute('data-original-title')) {
          titleEl.setAttribute('data-original-title', titleEl.textContent);
        }
        titleEl.innerHTML = '<span class="ka-player-preparing">Preparing audio<span class="ka-loading-dots"></span></span>';
      } else {
        var orig = titleEl.getAttribute('data-original-title');
        if (orig) {
          titleEl.textContent = orig;
          titleEl.removeAttribute('data-original-title');
        }
      }
    }
  }

  function stopReader() {
    isPlaying = false;
    isPreparingAudio = false;
    currentTotalDuration = 0;
    cancelAnimationFrame(rafId);
    if (currentAudio) {
      currentAudio.pause();
      if (currentAudio.src && currentAudio.src.startsWith('blob:')) {
        try { URL.revokeObjectURL(currentAudio.src); } catch (e) {}
      }
      currentAudio.src = '';
      currentAudio = null;
    }
    restoreDOM();
    togglePlayPauseUI(false);
    setLoading(false);
    if (player) player.classList.remove('is-active');
    if (mobileCard) mobileCard.classList.remove('is-active');
    checkTriggerVisibility();
    updateProgress(0, 0);
  }
  window.stopKaReadAloud = stopReader;

  function skipSeconds(s) {
    if (!currentAudio) return;
    var dur = getEffectiveDuration();
    var newTime = Math.max(0, Math.min(dur, currentAudio.currentTime + s));
    currentAudio.currentTime = newTime;

    updateProgress(newTime, dur);
    var rawMs = newTime * 1000;
    var idx = findWordAt(rawMs + LOOK_AHEAD_MS);
    if (idx !== -1) {
      highlightWord(idx, true);
    }
  }

  function setSpeed(v) {
    currentSpeed = v;
    if (currentAudio) currentAudio.playbackRate = v;
    if (speedBtn) speedBtn.textContent = v + 'x';
    if (mpSpeedBtn) mpSpeedBtn.textContent = v + 'x';
    if (speedDropdown) speedDropdown.classList.remove('is-open');
  }

  function toggleMute() {
    if (!currentAudio) return;
    currentAudio.muted = !currentAudio.muted;
    [deskVolToggle, mpMuteBtn].forEach(function(b) { if (b) b.classList.toggle('is-muted', currentAudio.muted); });
  }

  function updateMediaSession() {
    if (!('mediaSession' in navigator)) return;
    navigator.mediaSession.metadata = new MediaMetadata({ title: ARTICLE_TITLE, artist: 'Kerala Ayurveda', album: 'Read Aloud' });
    navigator.mediaSession.setActionHandler('play', function() { if (currentAudio) currentAudio.play(); });
    navigator.mediaSession.setActionHandler('pause', function() { if (currentAudio) currentAudio.pause(); });
    navigator.mediaSession.setActionHandler('seekbackward', function() { skipSeconds(-15); });
    navigator.mediaSession.setActionHandler('seekforward', function() { skipSeconds(15); });
  }

  if (playBtn) playBtn.addEventListener('click', togglePlayPause);
  if (mpPlayBtn) mpPlayBtn.addEventListener('click', togglePlayPause);
  if (rewindBtn) rewindBtn.addEventListener('click', function() { skipSeconds(-15); });
  if (mpRewindBtn) mpRewindBtn.addEventListener('click', function() { skipSeconds(-15); });
  if (forwardBtn) forwardBtn.addEventListener('click', function() { skipSeconds(15); });
  if (mpForwardBtn) mpForwardBtn.addEventListener('click', function() { skipSeconds(15); });
  if (stopBtn) stopBtn.addEventListener('click', stopReader);
  if (mpStopBtn) mpStopBtn.addEventListener('click', stopReader);

  if (speedBtn && speedDropdown) {
    speedBtn.addEventListener('click', function(e) { e.stopPropagation(); speedDropdown.classList.toggle('is-open'); });
    document.addEventListener('click', function() { speedDropdown.classList.remove('is-open'); });
    speedDropdown.querySelectorAll('button').forEach(function(b) {
      b.addEventListener('click', function() { setSpeed(parseFloat(b.getAttribute('data-speed'))); });
    });
  }
  if (mpSpeedBtn) {
    mpSpeedBtn.addEventListener('click', function() {
      var speeds = [1.0, 1.25, 1.5, 2.0];
      setSpeed(speeds[(speeds.indexOf(currentSpeed) + 1) % speeds.length]);
    });
  }
  if (deskVolToggle) deskVolToggle.addEventListener('click', toggleMute);
  if (mpMuteBtn) mpMuteBtn.addEventListener('click', toggleMute);
  if (mpTimeTotal) {
    mpTimeTotal.addEventListener('click', function() {
      isShowingRemaining = !isShowingRemaining;
      if (currentAudio) {
        updateProgress(currentAudio.currentTime, getEffectiveDuration());
      }
    });
  }
  if (mpRange) {
    function handleDragStart() {
      isScrubbing = true;
      renderScrubber(parseFloat(mpRange.value), true);
    }
    function handleDragEnd() {
      if (isScrubbing) {
        isScrubbing = false;
        var pct = parseFloat(mpRange.value);
        renderScrubber(pct, false);
        var dur = getEffectiveDuration();
        var targetSec = dur > 0 ? (pct / 100) * dur : 0;
        if (currentAudio) {
          currentAudio.currentTime = targetSec;
          var rawMs = targetSec * 1000;
          var idx = findWordAt(rawMs + LOOK_AHEAD_MS);
          if (idx !== -1) {
            highlightWord(idx, true);
          }
        }
        updateProgress(targetSec, dur);
      }
    }

    mpRange.addEventListener('pointerdown', handleDragStart);
    mpRange.addEventListener('touchstart', handleDragStart, { passive: true });
    mpRange.addEventListener('mousedown', handleDragStart);

    window.addEventListener('pointerup', handleDragEnd);
    window.addEventListener('touchend', handleDragEnd);
    window.addEventListener('touchcancel', handleDragEnd);
    window.addEventListener('mouseup', handleDragEnd);
    mpRange.addEventListener('change', handleDragEnd);

    mpRange.addEventListener('input', function() {
      isScrubbing = true;
      var pct = parseFloat(mpRange.value);
      renderScrubber(pct, true);
      var dur = getEffectiveDuration();
      var curSec = dur > 0 ? (pct / 100) * dur : 0;
      var curEl = mpTimeCurrent || document.getElementById('ka-mp-time-current');
      if (curEl) curEl.textContent = formatTime(curSec);
      var totalEl = mpTimeTotal || document.getElementById('ka-mp-time-total');
      if (totalEl) {
        var rem = Math.max(0, dur - curSec);
        totalEl.textContent = isShowingRemaining ? ('-' + (dur > 0 ? formatTime(rem) : '0:00')) : (dur > 0 ? formatTime(dur) : '0:00');
      }
      var deskTime = deskTimeDisplay || document.getElementById('ka-desk-time');
      if (deskTime) deskTime.textContent = formatTime(curSec) + ' / ' + (dur > 0 ? formatTime(dur) : '0:00');

      if (currentAudio) {
        var rawMs = curSec * 1000;
        var idx = findWordAt(rawMs + LOOK_AHEAD_MS);
        if (idx !== -1) {
          highlightWord(idx, false);
        }
      }
    });
  }
})();
